import React, { useState } from "react";
import { FaGithub } from "react-icons/fa";
import { CgIfDesign, CgDesignmodo } from "react-icons/cg";
import { FiMoon, FiSun } from "react-icons/fi";
import ProfileError from "./ProfileError";
import UserProfile from "./UserProfile";
import axios from "axios";
import RepositoryAnalyticsDialog from "./RepositoryAnalyticsDialog";

const GithubSearch = () => {
  const [profile, setProfile] = useState(null);
  const [repos, setRepos] = useState([]); // Add repos state
  const [username, setUsername] = useState("");
  const [error, setError] = useState(null);
  const [darkMode, setDarkMode] = useState(true);
  const [showAnalytics, setShowAnalytics] = useState(false);

  // Fetch user and repo info
  const findProfile = async function () {
    try {
      const userUrl = `https://api.github.com/users/${username}`;
      const reposUrl = `https://api.github.com/users/${username}/repos`;
      const userRes = await axios.get(userUrl);
      const reposRes = await axios.get(reposUrl);
      setProfile(userRes.data);
      setRepos(reposRes.data);
      setError(null);
      setUsername(""); // Clear input after successful search
    } catch (error) {
      setProfile(null);
      setRepos([]);
      setError("No Profile with this username, Please Try Again");
    }
  };

  function changeHandler(event) {
    setUsername(event.target.value);
  }

  function clickHandler() {
    if (username.trim() === "") {
      setError("Please enter a GitHub username");
      setProfile(null);
      setRepos([]);
      return;
    }
    findProfile();
  }

  function toggleTheme() {
    setDarkMode((prev) => !prev);
  }

  return (
    <div
      className={
        darkMode
          ? "min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-cyan-900 p-0"
          : "min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 to-white p-0"
      }
    >
      <div className="flex flex-col items-center justify-center w-full">
        <div className="mb-3 flex items-center justify-center relative">
          <FaGithub
            className={
              darkMode
                ? "text-5xl text-white mr-3"
                : "text-5xl text-gray-800 mr-3"
            }
          />
          <h1
            className={
              darkMode
                ? "text-4xl font-extrabold text-white tracking-wide"
                : "text-4xl font-extrabold text-gray-800 tracking-wide"
            }
          >
            GitHub Profile Finder
          </h1>
          <button
            className="ml-3 text-3xl rounded-full p-2 hover:bg-gray-200 transition"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            style={{ background: "transparent" }}
          >
            {darkMode ? (
              <FiSun className="text-yellow-500" />
            ) : (
              <FiMoon className={darkMode ? "text-white" : "text-gray-600"} />
            )}
          </button>
        </div>
        <p
          className={
            darkMode
              ? "mb-7 text-white text-center text-lg font-medium"
              : "mb-7 text-gray-700 text-center text-lg font-medium"
          }
        >
          Search for GitHub users and explore their profiles, repositories, and stats.
        </p>
        <button
          type="button"
          className={
            darkMode
              ? "flex items-center bg-gradient-to-r from-orange-400 to-pink-500 text-white px-7 py-3 rounded-full font-semibold shadow hover:scale-105 transition mb-7 text-lg"
              : "flex items-center bg-gradient-to-r from-orange-400 to-pink-500 text-white px-7 py-3 rounded-full font-semibold shadow hover:scale-105 transition mb-7 text-lg"
          }
          onClick={() => setShowAnalytics(true)}
        >
          <CgIfDesign className="mr-2 text-2xl" />
          <span>Repository Analytics</span>
        </button>
        {showAnalytics && (
          <RepositoryAnalyticsDialog
            onClose={() => setShowAnalytics(false)}
            darkMode={darkMode}
          />
        )}

        <div className="w-full flex items-center justify-center mb-12">
          <input
            placeholder="Enter a GitHub username..."
            value={username}
            onChange={changeHandler}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                clickHandler();
              }
            }}
            className={
              darkMode
                ? "w-[700px] px-6 py-4 rounded-full bg-white/20 text-white text-lg placeholder-gray-200 shadow focus:outline-none focus:ring-4 focus:ring-cyan-500 transition"
                : "w-[700px] px-6 py-4 rounded-full bg-gray-200 text-gray-700 text-lg placeholder-gray-500 shadow focus:outline-none focus:ring-4 focus:ring-cyan-500 transition"
            }
            style={{ border: "none" }}
          />
        </div>
        {error && <ProfileError error={error} />}
        {profile && (
          <UserProfile profile={profile} repos={repos} darkMode={darkMode} />
        )}
        <div
          className={
            darkMode
              ? "mt-10 text-center text-white text-sm flex items-center justify-center space-x-2 mb-2"
              : "mt-10 text-center text-gray-600 text-sm flex items-center justify-center space-x-2 mb-2"
          }
        >
          <span>Created by Harshit Pareek</span>
          <span className="mx-2 text-orange-500">
            <CgDesignmodo className="inline text-base" />
          </span>
          <span>with JavaScript | Using GitHub API</span>
        </div>
      </div>
    </div>
  );
};

export default GithubSearch;
